module.exports = __webpack_public_path__ + "img/stock6.62d83442.png";